var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{attrs:{"type":"file"},on:{"input":function($event){return _vm.$emit('input', $event.target.files[0])}}})}
var staticRenderFns = []

export { render, staticRenderFns }